var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-tabs",
        { attrs: { vertical: "", "nav-wrapper-class": "nav-vertical" } },
        [
          _c(
            "b-tab",
            { attrs: { title: "Bills of Materials" } },
            [
              _c("DocumentUpload", {
                attrs: { documentDetails: _vm.documentDetailsBOM },
                on: {
                  uploadFiles: function (files) {
                    return _vm.uploadFiles(files, "BOM")
                  },
                  deleteFile: function (id) {
                    return _vm.deleteFile(id, "BOM")
                  },
                  downloadFile: function (id, fileName) {
                    return _vm.downloadFile(id, fileName, "BOM")
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "b-tab",
            { attrs: { title: "Operation Steps" } },
            [
              _c("DocumentUpload", {
                attrs: { documentDetails: _vm.documentDetailsOps },
                on: {
                  uploadFiles: function (files) {
                    return _vm.uploadFiles(files, "Operation")
                  },
                  deleteFile: function (id) {
                    return _vm.deleteFile(id, "Operation")
                  },
                  downloadFile: function (id, fileName) {
                    return _vm.downloadFile(id, fileName, "Operation")
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "b-tab",
            { attrs: { title: "Cost" } },
            [
              _c("DocumentUpload", {
                attrs: { documentDetails: _vm.documentDetailsCost },
                on: {
                  uploadFiles: function (files) {
                    return _vm.uploadFiles(files, "Cost")
                  },
                  deleteFile: function (id) {
                    return _vm.deleteFile(id, "Cost")
                  },
                  downloadFile: function (id, fileName) {
                    return _vm.downloadFile(id, fileName, "Cost")
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "b-tab",
            { attrs: { title: "Quality Control" } },
            [
              _c("DocumentUpload", {
                attrs: { documentDetails: _vm.documentDetailsQC },
                on: {
                  uploadFiles: function (files) {
                    return _vm.uploadFiles(files, "Quality")
                  },
                  deleteFile: function (id) {
                    return _vm.deleteFile(id, "Quality")
                  },
                  downloadFile: function (id, fileName) {
                    return _vm.downloadFile(id, fileName, "Quality")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }